import { HttpError } from '../../../src/business/httpError';
import { AxiosError } from 'axios';
import { portal } from '../../assets/plugins/axios/axios';
import type { FindGenericRequest } from '../../models/requests/findGeneric.request';
import type { FindGenericResponse } from '../../models/responses/search/findGeneric.response';

class SearchService {
  public findGeneric = async (params: FindGenericRequest): Promise<FindGenericResponse> => {
    try {
      const { data } = await portal.get<{ data: FindGenericResponse }>('?method=search.findGeneric', {
        params,
        cancelPreviousRequests: true,
      });
      return data.data;
    } catch (error) {
      return Promise.reject(new HttpError(error as AxiosError));
    }
  };
}

export const searchService = new SearchService();
